import store from 'redux/store'
import {useState} from "react";

const useTheme = () => {
    const [theme, setTheme] = useState({primary: '#3f50b5', secondary: '#f44336'});
    store.subscribe(() => {
        const theme = store.getState().inbox?.theme;
        if (theme) setTheme(theme);
    });
    return theme
};


export default useTheme;
